import React, {Component, PropTypes} from 'react'
import EmojiPicker from 'emojione-picker'
import Textarea from 'react-textarea-autosize'
import '../../../node_modules/emojione-picker/css/picker.css'
import ChatTabs from './ChatTabs'
import ChatContent from './ChatContent'
import CSSModules from 'react-css-modules'
import styles from './chatBlock.css'
import { PUBLIC_CHAT_ID, PRIVATE_CHAT_ID, TEAM_CHAT_ID } from '../../actions'
import {withRouter} from 'react-router'
import MiniChatTabs from './MiniChatTabs'
/**
 *  Компонент ChatBloc.
 *  Используется для вывода блока чата в лк и в админке
 *
 */
class ChatBlock extends Component {
  /**
   * @memberof ChatBlock
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {func} propTypes.changeChat Выбор чата
   * @prop {func} propTypes.onMessageSend Отправка сообщений на сервер
   * @prop {object} propTypes.privateChats  Приватный чат
   * @prop {object} propTypes.teamChats Командный чат
   * @prop {object} propTypes.commonChats Общий чат
   * @prop {bool} propTypes.admin Проверяет юзера - админ или нет
   * */

  static propTypes = {
    changeChat: PropTypes.func.isRequired,
    onMessageSend: PropTypes.func.isRequired,
    privateChats: PropTypes.array,
    teamChats: PropTypes.array,
    commonChats: PropTypes.array,
    admin: PropTypes.bool
  }
  constructor(props) {
    super(props)

    this.state = {
      showEmojiPopup: false,
      selectChat: 0
    }
  }

  toggleEmojiPopup() {
    this.setState({showEmojiPopup: !this.state.showEmojiPopup})
  }

  getEmoji(unicode) {
    const point = Number('0x' + unicode)
    const offset = point - 0x10000
    const lead = 0xd800 + (offset >> 10)
    const trail = 0xdc00 + (offset & 0x3ff)
    const arr = [lead.toString(16), trail.toString(16)]

    return arr
      .map((el) => parseInt(el, 16))
      .map((el) => String.fromCharCode(el))
      .join('')
  }

  appendEmoji(unicode) {
    this.refs.message.value += this.getEmoji(unicode)
  }

  renderChatName(){
    const {chat} = this.props
    if(chat === PUBLIC_CHAT_ID) {
      return 'Общий'
    } else if (chat === PRIVATE_CHAT_ID){
      return 'С тренером'
    } else if (chat === TEAM_CHAT_ID){
      return 'С командой'
    } else {
      return 'Чат не выбран'
    }
  }

  toChat(){
    const {changeChat, chat, router, typeId} = this.props
    router.push('/chats/' + typeId)
  }
  handleDocumentClick = (e) => {
    if(this.refs.btn !== e.target){
      if(this.state.showEmojiPopup){
        this.setState({
          showEmojiPopup: false
        })
      }
    }
  }

  changeActiveTab(tab){
    this.setState({
      selectChat: tab
    })
  }


  componentDidMount () {
    window.addEventListener('click', this.handleDocumentClick)
  }

  componentWillUnmount () {
    window.removeEventListener('click', this.handleDocumentClick)
  }

  closeMiniChat(){
    const {toggleMiniChat} = this.props
    toggleMiniChat(false)
    this.changeActiveTab(0)
  }

  render() {
    const {
      // Data
      userId,
      // comments = [],
      // sendButtonText,
      placeholderText,
      // Flags
      isFetching,
      isFetchingChat,
      onMessageChanged,
      changeChat,
      onMessageSend,
      userInfo,
      miniChatOpen,
      privateChats,
      toggleMiniChat,
      toggleMiniChatSmall,
      teamChats,
      commonChats,
      miniChatSmall,
      chat,
      unReadPublicChat,
      unReadPrivateChat,
      unReadTeamChat,
      role,
      miniChat,
      admin
    } = this.props
    let workTeam = null
    console.log('this.props-block')
    console.log(this.props)
    if(!admin && userInfo.data.customUserFields){
      workTeam = userInfo.data.customUserFields.workTeam
    }
    const {
      showEmojiPopup
    } = this.state

    var categories = {
      people: {
        title: 'Люди',
        emoji: 'smile'
      },
      nature: {
        title: 'Природа',
        emoji: 'mouse'
      },
      food: {
        title: 'Еда',
        emoji: 'pizza'
      },
      activity: {
        title: 'Развлечения',
        emoji: 'soccer'
      },
      travel: {
        title: 'Путешествия',
        emoji: 'earth_americas'
      }
    }

    return (
      <div>
        {miniChat &&
          <MiniChatTabs
            role={role}
            chat={chat}
            workTeam={workTeam}
            miniChatOpen={miniChatOpen}
            toggleMiniChat={toggleMiniChat}
            changeChat={changeChat}
            changeActiveTab={this.changeActiveTab.bind(this)}
            unReadPublicChat={unReadPublicChat}
            unReadPrivateChat={unReadPrivateChat}
            unReadTeamChat={unReadTeamChat}
            isFetchingChat={isFetchingChat}
            selectChat={this.state.selectChat}
          />
        }

        { !miniChat || miniChatOpen ? <div className={miniChat && miniChatSmall ? styles.chatInnerBlockSmall : styles.chatInnerBlock}>
        {!admin && !miniChat ? <ChatTabs
                      role={role}
                      chat={chat}
                      workTeam={workTeam}
                      changeChat={changeChat.bind(this)}
                  /> : null}

        {
          miniChat &&
          <div className={styles.miniChatHeader}>
            <div className={styles.miniChatTitle}>
              {this.renderChatName()}
            </div>
            <div className={styles.miniChatAction}>
              <div className={styles.miniChatActionItem} onClick={this.toChat.bind(this)}>
                <svg className={styles.minionChatCloseIcon}>
                  <use xlinkHref="#arrow_rigth"></use>
                </svg>
              </div>
              <div className={styles.miniChatActionItem} onClick={() => toggleMiniChatSmall(true)}>
                <svg className={styles.minionChatCloseIcon}>
                  <use xlinkHref={miniChatSmall ? "#arrow_diagonal":"#arrow_inner"}></use>
                </svg>
              </div>
              <div className={styles.miniChatActionItem} onClick={() => this.closeMiniChat()}>
                 <svg className={styles.minionChatCloseIcon}>
                    <use xlinkHref="#ico-close"></use>
                  </svg>
              </div>
            </div>
          </div>
        }

        <div className={styles.chatSpinner}>
          <div className={styles.spinner}></div>
        </div>
        {role !== 2 && chat === 2
          ? <ChatContent
              miniChatSmall={miniChat && miniChatSmall}
              miniChat={miniChat}
              isFetchingChat={isFetchingChat}
              isFetching={isFetching}
              isActive={chat === PRIVATE_CHAT_ID}
              userId={userId}
              gender={userInfo.data.gender}
              list={privateChats}
          />
          : null
        }
        {role !== 2 && !admin && workTeam && chat === 7
          ? <ChatContent
            miniChatSmall={miniChat && miniChatSmall}
            miniChat={miniChat}
            isFetchingChat={isFetchingChat}
            isFetching={isFetching}
            gender={userInfo.data.gender}
            isActive={chat === TEAM_CHAT_ID}
            userId={userId}
            list={teamChats}
          />
          : null
        }
          { chat === 1 &&
        <ChatContent
          miniChatSmall={miniChat && miniChatSmall}
          miniChat={miniChat}
          isFetchingChat={isFetchingChat}
          isFetching={isFetching}
          gender={userInfo.data.gender}
          isActive={chat === PUBLIC_CHAT_ID}
          userId={userId}
          list={commonChats}
        />}
        <div className={miniChat ? styles.chatFormMini : styles.chatForm}>
          <div className={styles.chatFormInner}>
            <div className={miniChat ? styles.textAreaMini : styles.textArea}>
              <textarea className={miniChat ? styles.textareaFieldMini : styles.textareaField}
                        ref="message"
                        onChange={(e) => onMessageChanged(e)}
                        placeholder="Ваше сообщение"
                        onFocus={(e) => e.target.placeholder = ""}
                        onBlur={(e) => e.target.placeholder = "Ваше сообщение"}
              >
              </textarea>
              { /*onKeyDown={e => {
              if (e.keyCode === 13 && !e.shiftKey) {
                onMessageSend(this.refs.message.value)
                this.refs.message.value = ''
              }
            }}*/}
              {
                showEmojiPopup ? (
                  <div className={styles.chatEmoji}>
                    <EmojiPicker
                      categories={categories}
                      onChange={({unicode}) => this.appendEmoji(unicode)}
                    />
                  </div>
                ) : null
              }
              <button
                ref = 'btn'
                onClick={() => this.toggleEmojiPopup()}
                className={miniChat ? styles.chatEmojiButtonMini : styles.chatEmojiButton}>
                😀
              </button>
            </div>
            <div className={miniChat ? styles.btnChatMini : styles.btnChat}
                 onClick={() => {
                   onMessageSend(this.refs.message.value)
                   this.refs.message.value = ''
                 }}>
              {miniChat
                ? <div className={styles.btnChatMiniIcon}>
                    <img src="/assets/img/png/submit.png" alt=""/>
                  </div>
                : <div className={styles.btnChatTitle}>Отправить</div>
              }

              <div className={styles.btnChatIco}>
                <svg className={styles.svgIconBoldArrowUp}>
                  <use xlinkHref="#ico-bold-arrow-up"></use>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>: null}
      </div>
    )
  }
}
const ChatBlockComponent = withRouter(ChatBlock)
export default CSSModules(ChatBlockComponent, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/Chat/ChatBlock.js